import { Controller, useFormContext } from 'react-hook-form';
import { Input, Label, FormGroup } from '@polichat/flamboyant';
import { ProductForm, BotForm } from './index';
import styles from '../../styles.module.css';
import { FeatureMessage } from '../../components/FeatureMessage';
import {
  COMMERCIAL_VALUES,
  COMMERCIAL_OPTIONS,
  CLUSTER_VALUES,
} from '../../useFinishChatForm/types';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';
import { useMemo } from 'react';

export function SalesForm() {
  const { control, watch } = useFormContext();
  const commercialType = watch('commercial.type');
  const isSaleCompleted = commercialType === COMMERCIAL_VALUES.sale_completed;

  const cluster = watch('cluster');
  const isClusterActive = cluster === CLUSTER_VALUES.active;

  const showBotOption =
    isClusterActive && commercialType !== COMMERCIAL_VALUES.other;

  // Traduções para opções comerciais
  const saleMadeText = useGlotaT('spa.chat.finishChat.saleMade');
  const inNegotiationText = useGlotaT('spa.chat.finishChat.inNegotiation');
  const lostLeadText = useGlotaT('spa.chat.finishChat.lostLead');
  const othersText = useGlotaT('spa.chat.finishChat.others');

  // Opções traduzidas
  const translatedCommercialOptions = useMemo(
    () =>
      COMMERCIAL_OPTIONS.map((opt) => {
        let label = opt.label;
        if (opt.value === COMMERCIAL_VALUES.sale_completed)
          label = saleMadeText;
        else if (opt.value === COMMERCIAL_VALUES.under_negotiation)
          label = inNegotiationText;
        else if (opt.value === COMMERCIAL_VALUES.lead_lost)
          label = lostLeadText;
        else if (opt.value === COMMERCIAL_VALUES.other) label = othersText;
        return { ...opt, label };
      }),
    [saleMadeText, inNegotiationText, lostLeadText, othersText]
  );

  return (
    <>
      <div
        className={styles.fieldContainer}
        data-testid="finish-chat-commercial-container"
      >
        <Controller
          name="commercial.type"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <FormGroup
                tag="fieldset"
                data-testid="finish-chat-commercial-fields-container"
              >
                {translatedCommercialOptions.map((option) => (
                  <FormGroup check key={option.value}>
                    <Input
                      type="radio"
                      id={option.value}
                      name="commercial.type"
                      value={option.value}
                      checked={field.value === option.value}
                      onChange={field.onChange}
                      data-testid={`finish-chat-commercial-option-${option.value}`}
                    />
                    <Label
                      check
                      htmlFor={option.value}
                      data-testid={`finish-chat-commercial-label-${option.value}`}
                    >
                      {option.label}
                    </Label>
                  </FormGroup>
                ))}
              </FormGroup>
              {/* Error */}
              {fieldState?.error?.message && (
                <span
                  className={styles.fieldError}
                  data-testid="finish-chat-commercial-error"
                >
                  {fieldState?.error?.message}
                </span>
              )}
            </>
          )}
        />
        {isSaleCompleted && (
          <>
            <hr className={styles.modalDivider} />
            <ProductForm />
          </>
        )}
        {showBotOption ? (
          <>
            <hr className={styles.modalDivider} />
            <BotForm />
          </>
        ) : (
          <div className={styles.fieldContainer}>
            {/* <hr className={styles.modalDivider} /> */}
            <FeatureMessage />
          </div>
        )}
      </div>
    </>
  );
}
